import { FormControlLabel, Radio } from '@material-ui/core';
import InlineFormRadioGroup from 'pages/Auth/Registration/components/InlineFormRadioGroup';
import { useSelector } from 'react-redux';
import { Field } from 'redux-form';
import styled from 'styled-components';

const AuctionTypeWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  margin-left: 20px;

  @media (max-width: 567px) {
    margin-left: 0;
  }
`;

export const AuctionTypeComponent = ({ disabled = false }) => {
  const user = useSelector(state => state.user.user);
  if (!user || user.role === 'seller') return null;

  return (
    <AuctionTypeWrapper>
      <div>Auctions</div>
      <Field name="auction_type" component={InlineFormRadioGroup}>
        <FormControlLabel disabled={disabled} value={'autoaxess'} control={<Radio />} label="AutoAxess" />
        <FormControlLabel disabled={disabled} value={'frontline'} control={<Radio />} label="Frontline" />
        <FormControlLabel disabled={disabled} value={'second_chance'} control={<Radio />} label="Second Chance" />
      </Field>
    </AuctionTypeWrapper>
  );
};
